angular
  .module('survey')
  .controller('SurveyController', [
    '$scope',
    '$window',
    'merge',
    'submissionHandler',
    'validator',
    'queryParser',
    '$timeout',
    'analytics',
    'rangeConfig',
    SurveyController,
  ]);

angular.module('survey').directive('survey', function () {
  return {
    restrict: 'C', //matches class name
    link: function (scope, element) {
      // MutationObserver detects changes in the DOM so this directive can 'listen' to changes in the DOM
      const observer = new MutationObserver(function (mutations) {
        // loop through the mutations/changes in the dom
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes) {
            for (let i = 0; i < mutation.addedNodes.length; i++) {
              const addedNode = mutation.addedNodes[i];
              // the mutation we specifically care about is if we get a new node that has the class hide-me
              if (
                addedNode.nodeType === 1 &&
                addedNode.classList.contains('hide-me')
              ) {
                // if we see an new elem with the class hide-me, we want to add class hide-me to parent element
                // this is so for elements like the radio button if the text is hidden, the radio button should be hidden too 
                const parentElement = addedNode.parentElement;
                if (parentElement) {
                  parentElement.classList.add('hide-me');
                }
              }
            }
          }
        });
      });

      // observer, which is an instance of Mutation Observer, should be setup to watch for changes in the child elements and their of their descendents in the document (this means whenever an elem is added or removed the MutationObserver will trigger)
      observer.observe(document, { childList: true, subtree: true });

      // if controller is removed from the DOM, destroy is triggered and we want to disconnect the observer
      scope.$on('$destroy', function () {
        // this is so we can avoid mem leaks
        observer.disconnect();
      });
    },
  };
});

function SurveyController(
  $scope,
  $window,
  merge,
  submissionHandler,
  validator,
  queryParser,
  $timeout,
  analytics,
  rangeConfig
) {
  var vm = this;

  vm.getQuestionsOnPage = function (page) {
    return vm.config.questions.filter(function (question) {
      return question.page === page;
    });
  };

  var pageHistory = [];

  vm.nextPageText = function (currentPage) {
    const lastPage = vm.countPages();
    if (currentPage === lastPage) {
      return vm.config.last_page_button_text;
    }
    return vm.config.next_button_text;
  };

  vm.nextPage = function () {
    // Validate this page
    var isLastPage = vm.page === vm.countPages();
    var stateForValidator = {
      first_name: vm.first_name,
      last_name: vm.last_name,
      zip: vm.zip,
      email: vm.email,
      cell_phone: vm.cell_phone,
      questions: vm.config.questions,
      responses: vm.responses,
      require_email_field: vm.config.require_email_field,
      require_cell_phone: vm.config.require_cell_phone,
      last_page: isLastPage,
      page: vm.page,
      query: window.location.search,
      onepage: vm.onepage,
      default_redirect: vm.redirect_param || vm.config.default_redirect,
      append_refcode: vm.config.append_refcode,
      append_refcode2: vm.config.append_refcode2,
      sustainers: vm.sustainers,
      layout: vm.config.layout,
    };
    vm.errors = validator.validatePage(stateForValidator);
    if (Object.keys(vm.errors).length) {
      // move focus to where the error is
      $window.document.getElementById(Object.keys(vm.errors)[0]).focus();
      
      // Prevent advancement to the next page if there are errors
      return;
    }

    // see if the user should be redirected somewhere special
    var redirect = validator.determineRedirect(stateForValidator);

    var submitConfig = {
      email: vm.email,
      cell_phone: normalizeSms(vm.cell_phone),
      first_name: vm.first_name,
      last_name: vm.last_name,
      zip: vm.zip,
      values: vm.responses[vm.page - 1],
      done: (isLastPage || redirect.type) && redirect.type !== 'page',
      page: vm.page,
      submissionId: vm.submissionId,
      code: vm.code,
      survey_variant_id: vm.config.id,
      url: $window.location.href,
    };

    if (vm.onepage) {
      submitConfig.page = vm.countPages();
      submitConfig.done = true;
      submitConfig.values = {};
      for (var i = 0; i < vm.responses.length; i++) {
        Object.assign(submitConfig.values, vm.responses[i]);
      }
    }

    pageHistory.push(vm.page);

    if (redirect.type === 'url' || isLastPage || vm.onepage) {
      vm.submitting = true;

      var redirectFn = function () {
        vm.submitting = false;
        if (redirect.type === 'page') {
          vm.page = redirect.page;
        } else if (redirect.type === 'url') {
          $window.location = redirect.url;
        } else {
          // show thanks page if no URL
          vm.showing_thanks_page = true;
          analytics.customEvent('surveyThanks', {
            showing_thanks_page: vm.showing_thanks_page,
          });
        }
      };

      submissionHandler.submit(submitConfig).then(redirectFn, redirectFn);
    } else {
      submissionHandler.submit(submitConfig);
      if (redirect.type === 'page') {
        vm.page = redirect.page;
      } else if (redirect.type === 'thanks') {
        vm.showing_thanks_page = true;
        analytics.customEvent('surveyThanks', {
          showing_thanks_page: vm.showing_thanks_page,
        });
      } else {
        vm.page++;
      }
    }

    // determine if the question should auto-submit
    if (
      vm.config.questions.filter(
        (question) =>
          question.default_redirect_behavior_type === 'auto_progress'
      )
    ) {
      autoProgress(vm.page);
    }
  };
  vm.prevPage = function () {
    if (!vm.submitting) {
      vm.page = pageHistory.pop();
    }
    // determine if the question should auto-submit
    if (
      vm.config.questions.filter(
        (question) =>
          question.default_redirect_behavior_type === 'auto_progress'
      )
    ) {
      autoProgress(vm.page);
    }
  };
  vm.countPages = function () {
    return vm.config.questions.reduce(function (max, question) {
      return question.page > max ? question.page : max;
    }, 0);
  };
  vm.getPercentageCompletion = function (offset) {
    // Accepts an optional offset for surveys with a "petition" or non-survey introduction page.
    // offset should be an integer and represent how many pages to skip before beginning the progress bar
    if (offset) {
      return ((vm.page - (1 + offset)) / (vm.countPages() - offset)) * 100;
    } else {
      return ((vm.page - 1) / vm.countPages()) * 100;
    }
  };

  $scope.$watch(vm.survey, () => vm.initialize());

  $scope.$on('botFormFill', (event, { questionId, value }) => {
    const question = vm.config.questions.filter(
      (q) => q.id === parseInt(questionId)
    )[0];

    if (questionId === 'email') {
      vm.email = value;
    } else if (questionId === 'cell_phone') {
      vm.cell_phone = value;
    } else if (questionId === 'first_name') {
      vm.first_name = value;
    } else if (questionId === 'last_name') {
      vm.last_name = value;
    } else if (questionId === 'zip') {
      vm.zip = value;
    } else if (question && question.type === 'Radio') {
      vm.responses[vm.page - 1][questionId] = { option_id: value };
    } else {
      vm.responses[vm.page - 1][questionId] = { text: value };
    }
  });

  $scope.$on('botFinishConversation', (event) => {
    vm.nextPage();
    document.getElementById('cf-context').style.display = 'none';
  });

  vm.initialize = function () {
    // initialize page
    vm.page = vm.config.start_page || 1;
    vm.disable_options = false;

    // initialize submissionId (which is a UUID so we can generate it in the client)
    vm.submissionId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );

    // initialize response pages
    vm.responses = [];
    var pageCount = vm.countPages();
    for (var i = 0; i < pageCount; i++) {
      var page = {};
      var questionsOnPage = vm.getQuestionsOnPage(i + 1);
      for (var j = 0; j < questionsOnPage.length; j++) {
        let q = questionsOnPage[j];
        if (q.type === 'Range') {
          // initialize ranges (otherwise they will be null if the user leaves them on 50)
          page[q.id] = { numeric_value: rangeConfig(q.range_ticks).default };
        } else {
          page[q.id] = null;
        }
        q.getSelectedOption = function () {
          const response = vm.responses[q.page - 1][q.id];
          if (!response) return null;
          const option = q.options.find(
            (i) => i.id === parseInt(response.option_id)
          );
          return option;
        };
      }
      vm.responses.push(page);
    }

    var queryParams = queryParser($window.location.search);
    vm.code = queryParams.code;
    vm.email = queryParams.email;
    vm.cell_phone = queryParams.cell_phone;
    vm.sustainers = queryParams.sustainers;
    vm.first_name = queryParams.first_name;
    vm.last_name = queryParams.last_name;
    vm.zip = queryParams.zip;
    if (vm.sustainers === undefined || vm.sustainers === null) {
      vm.sustainers = false;
    } else if (vm.sustainers === 'false' || vm.sustainers === '0' || vm.sustainers === 0 || vm.sustainers === false) {
      vm.sustainers = false;
    } else {
      vm.sustainers = true;
    }
    vm.onepage = queryParams.onepage;
    if (
      queryParams.redirect &&
      queryParams.als_redirect_encode === 'base64url'
    ) {
      vm.redirect_param = $window.atob(queryParams.redirect);
    } else {
      vm.redirect_param = queryParams.redirect;
    }

    // apply merge fields
    merge(vm.config, $window.location.search);

    // Assign a question's value if it has a prefill param specified
    Object.keys(queryParams).forEach((key) => {
      vm.config.questions.forEach((question) => {
        if (question.prefill_slug === key) {
          vm.responses[question.page - 1][question.id] = {
            text: queryParams[key],
          };
        }
      });
    });

    // allow merge fields on donate_button fields for USO template
    var donateButton = document.getElementById('donate-button');
    if (donateButton !== null) {
      donateButton.href = vm.config.donate_button_link;
      donateButton.getElementsByTagName('span')[0].innerHTML =
        vm.config.donate_button_text;
    }

    if (vm.config.quiz) {
      vm.score = 0;
      $scope.$watch(
        () => vm.responses,
        () => (vm.score = scoreQuiz()),
        true
      );
    }

    // determine if the question should auto-submit
    if (
      vm.config.questions.filter(
        (question) =>
          question.default_redirect_behavior_type === 'auto_progress'
      )
    ) {
      autoProgress(vm.page);
    }
  };

  $scope.$watch(
    () => vm.page,
    function () {
      $scope.$broadcast('pageChange', vm.page);
      if (window.innerWidth > 480) {
        // on desktop scroll to the top of the page
        window.scrollTo(0, 0);
      } else {
        // on mobile scroll to the top of the survey content
        var top = document.getElementById('survey-body-top');
        if (top) top.scrollIntoView();
      }
      // focus on the first question on the next page, for screen reader accessibility
      if (vm.page > 1 && !vm.onepage) {
        $timeout(
          function () {
            $window.document
              .getElementById(
                `${vm.config.questions.filter((i) => i.page === vm.page)[0].id}`
              )
              .focus();
          }.bind(this),
          500
        );
      }
    }
  );

  $scope.$on('pageChange', () => {
    // One each page change, once the DOM has loaded
    angular.element(document).ready(() => {
      var customEvents = {
        page: vm.page,
        showing_thanks_page: vm.showing_thanks_page || false,
      };
      analytics.customEvent('pageView', customEvents);
    });
  });

  // add a delay for the auto-progress questions
  vm.delaySubmit = function () {
    vm.disable_options = true;
    $timeout(
      function () {
        vm.nextPage();
        vm.disable_options = false;
      }.bind(this),
      750
    );
  };

  vm.getResponse = function (pageIndex, questionIndex) {
    if (!vm.responses || !vm.responses[pageIndex]) return null;
    (pageIndex = parseInt(pageIndex)),
      (questionIndex = parseInt(questionIndex));
    const questionsOnPage = vm.config.questions
      .filter((i) => i.page === pageIndex + 1)
      .sort((a, b) => {
        if (a.display_order && !b.display_order) return -1;
        else if (!a.display_order && b.display_order) return 1;
        else if (!a.display_order && !b.display_order) return 0;
        else if (a.display_order > b.display_order) return 1;
        else if (a.display_order < b.display_order) return -1;
        else return 0;
      });
    const question = questionsOnPage[questionIndex];
    if (!question || !vm.responses) return null;
    const response = vm.responses[pageIndex][question.id];
    if (!response) return null;
    if (response.options) {
      return Object.keys(response.options)
        .filter((optid) => response.options[optid].checked)
        .map(
          (optid) =>
            question.options.find((i) => i.id === parseInt(optid)).text +
            (response.options[optid].text ? response.options[optid].text : '')
        )
        .join(',');
    } else if (response.option_id) {
      return question.options.find((i) => i.id === parseInt(response.option_id))
        .text;
    } else if (typeof response.numeric_value === 'number') {
      // use typeof b/c user may have entered 0
      return response.numeric_value;
    } else if (response.text) {
      return response.text;
    } else {
      return null;
    }
  };

  function scoreQuiz() {
    if (!vm.config.quiz) return null;
    var score = 0;
    for (var i = 0; i < vm.config.questions.length; i++) {
      const question = vm.config.questions[i];
      if (question.quiz_question) {
        const option =
          question.getSelectedOption && question.getSelectedOption();
        if (option && option.correct) score++;
      }
    }
    return score;
  }

  function autoProgress(page) {
    vm.disable_auto_submit = true;
    // only auto-submit if it is the only question on the first page, including when onepage is true
    if (vm.config.questions[page - 1] !== undefined) {
      if (
        (!vm.onepage &&
          vm.config.questions.filter((question) => question.page === page)
            .length === 1 &&
          vm.config.questions.filter((question) => question.page === page)[0]
            .default_redirect_behavior_type === 'auto_progress') ||
        (vm.onepage &&
          vm.config.questions.length === 1 &&
          vm.config.questions.filter((question) => question.page === page)[0]
            .default_redirect_behavior_type === 'auto_progress')
      ) {
        vm.disable_auto_submit = false;
      }
    }
  }

  // If the survey template uses a custom question, use that
  // Otherwise, serve from the common question components
  vm.findPath = function (question_type) {
    var selector = `#${question_type}.html`;
    var custom_question_el = document.querySelectorAll(
      selector.replace(/[ .]/g, '\\$&')
    );
    var path = '/static/survey_templates/common/';
    if (custom_question_el.length > 0) {
      path = '';
    }

    return path;
  };

  // Handle phone numbers submitted in various formats
  // See: https://stackoverflow.com/a/43687969
  function normalizeSms(phone) {
    if (phone === undefined) return null;
    var number = phone.replace(/[^\d+]+/g, '').replace(/^00/, '+');
    if (number.match(/^1/)) number = '+' + number;
    if (!number.match(/^\+/)) number = '+1' + number;
    return number;
  }
}
